import { Button, Dialog, DialogPanel, DialogTitle } from '@headlessui/react'
import { useState, useEffect, useCallback } from 'react'

import { useConnection, useWallet } from "@solana/wallet-adapter-react";
import { LAMPORTS_PER_SOL } from "@solana/web3.js";
import UserWallet from '../UserWallet/UserWallet';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { setIsDataLoading, setPromise, setUserSessionData } from '../../lib/userSessionSlice';

let currentWallet = null
let referralAddress = process.env.REACT_APP_REFERRAL_ADDRESS

export default function ConnectWallet() {
    let [isOpen, setIsOpen] = useState(false)
    const [userWalletAddress, setUserWalletAddress] = useState(null);
    const { connection } = useConnection();
    const { select, wallets, publicKey, disconnect, connecting, connected } = useWallet();
    const [searchParams, setSearchParams] = useSearchParams()


    const dispatch = useDispatch()

    const setPromiseState = (data) => dispatch(setPromise(data))
    const setUserSession = (data) => dispatch(setUserSessionData(data))

    let address = searchParams.get('address')

    async function createUser() {

        if (publicKey?.toBase58()) {
            setPromiseState({ userSession: { isLoading: true } })
            let baseUrl = process.env.REACT_APP_API_BASE_URL;
            let endpoint = `${baseUrl}/users/create`;

            let data = {
                address: publicKey?.toBase58(),
                referredBy: address ? address : referralAddress,
            };

            let config = {
               
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": process.env.REACT_APP_API_KEY
                },
             
            }

            try {
                let balance = await window?.web3Connection?.getBalance(publicKey) / 1e9
                let server = await axios.post(endpoint, data, config);
                let jupiter = await axios.get('https://api.jup.ag/price/v2?ids=So11111111111111111111111111111111111111112').then((res) => res.data.data?.["So11111111111111111111111111111111111111112"]?.price)

                const [solBalance, response, solPrice] = await Promise.all([balance, server, jupiter])
                setPromiseState({ userSession: { isLoading: false, success: true } })
                setUserSession({ ...response.data.data, solBalance, solPrice })
            } catch (error) {
                console.error("Error:", error.response?.data || error.message);
                setPromiseState({ userSession: { isError: true } })
            }
        }
    }

    useEffect(() => {
        if (publicKey?.toBase58()) {

        }


    }, [publicKey])


    function open() {
        setIsOpen(true)
    }

    function close() {
        setIsOpen(false)
    }
    useEffect(() => {
        if (!connection || !publicKey) {
            return;
        }

        connection.onAccountChange(
            publicKey,
            (updatedAccountInfo) => {
                // setBalance(updatedAccountInfo.lamports / LAMPORTS_PER_SOL);
            },
            "confirmed"
        );

        connection.getAccountInfo(publicKey).then((info) => {
            if (info) {
                // setBalance(info?.lamports / LAMPORTS_PER_SOL);
            }
        });
    }, [publicKey, connection]);

    useEffect(() => {
        setUserWalletAddress(publicKey?.toBase58());
        createUser()
    }, [publicKey]);



    useEffect(() => {
        if (connected) {
            currentWallet = wallets.filter((wallet) => wallet?.adapter?.connected)
        }
    }, [connected]);

    const handleWalletSelect = async (walletName) => {
        if (walletName) {
            try {
                select(walletName);

                currentWallet = wallets.filter((wallet) => wallet.adapter.connected)
                setIsOpen(false);
            } catch (error) {
                console.log("wallet connection err : ", error);
            }
        }
    };

    const handleDisconnect = async () => {
        disconnect();
    };











    return (
        <>
            {!connected ? <Button
                onClick={open}
            >
                <div className=" flex gap-2 items-center group cursor-pointer bg-yellow-500 border border-neutral-800 px-4 py-2 rounded">
                    <div className="relative w-6 h-6 ">
                        <div className="flex items-center justify-center">
                            <img src={wallets[0].adapter.icon} alt="" className="absolute top-0 w-6 h-6 rounded-full shadow-xl  outline outline-black bg-black z-[10] transition-all" />
                            <img src={wallets[1].adapter.icon} alt="" className="absolute top-0 left-0 w-6 h-6 rounded-full  bg-black z-[9] transition-all group-hover:left-5" />
                            <img src={wallets[2].adapter.icon} alt="" className="absolute top-0 left-0 w-6 h-6 rounded-full  bg-black z-[8] transition-all group-hover:left-10" />
                            <img src={wallets[3].adapter.icon} alt="" className="absolute top-0 left-0 w-6 h-6 rounded-full  bg-black z-[7] transition-all group-hover:left-16" />
                        </div>
                    </div>
                    <p className="text-black group-hover:invisible transition-all font-bold ">Connect</p>
                </div>
            </Button>
                :
                <UserWallet currentWallet={currentWallet} publicKey={publicKey} disconnect={disconnect} connection={connection} />

            }
            {/* <Button>
                <div className=" flex gap-2 items-center  cursor-pointer bg-yellow-500 border border-neutral-800 px-4 py-2 rounded">
                <img src={currentWallet?.[0]?.adapter?.icon} alt="" className=" w-8 h-8 rounded-full shadow-xl  outline bg-black z-50 transition-all" />
                <div className='grid'>
                <p className="text-black text-sm font-bold ">{publicKey?.toBase58()?.slice(0, 4) + "..." + publicKey?.toBase58()?.slice(40, publicKey.toBase58().length)}</p>
                </div>
                </div>
                </Button> */}

            <Dialog open={isOpen} as="div" className="relative !z-50 focus:outline-none  " onClose={close}>
                <div className="fixed inset-0 z-10 w-screen overflow-y-auto  ">
                    <div className="flex min-h-full items-center justify-center p-4 backdrop-blur ">
                        <DialogPanel
                            transition
                            className="w-full space-y-10 max-w-md rounded-xl bg-white/10 p-6 backdrop-blur-2xl duration-300 ease-out data-[closed]:transform-[scale(95%)] data-[closed]:opacity-0"
                        >
                            <DialogTitle as="h3" className="text-base/7 font-medium text-white">
                                Select a wallet Provider
                            </DialogTitle>

                            <div className='flex flex-col gap-2'>

                                {
                                    wallets.map((wallet) => (
                                        <div
                                            key={wallet.adapter.name}
                                            //onClick={() => select(wallet.adapter.name)}
                                            onClick={() => handleWalletSelect(wallet.adapter.name)}
                                            className=" bg-white/10 px-5 py-2 rounded-lg cursor-pointer hover:bg-yellow-500/5 hover:text-white text-[20px] text-white font-slackey flex w-full justify-start items-center "
                                        >
                                            <div className="flex ">
                                                <img
                                                    src={wallet.adapter.icon}
                                                    alt={wallet.adapter.name}
                                                    height={30}
                                                    width={30}
                                                    className="mr-5 "
                                                />
                                            </div>
                                            <div className="font-slackey text-white wallet-name text-[20px]">
                                                {wallet.adapter.name}
                                            </div>
                                        </div>))

                                }

                            </div>

                            <div className="mt-4">
                                <Button
                                    className="inline-flex items-center gap-2 rounded-md bg-gray-700 py-1.5 px-3 text-sm/6 font-semibold text-white shadow-inner shadow-white/10 focus:outline-none data-[hover]:bg-gray-600 data-[focus]:outline-1 data-[focus]:outline-white data-[open]:bg-gray-700"
                                    onClick={close}
                                >
                                   Close
                                </Button>
                            </div>
                        </DialogPanel>
                    </div>
                </div>
            </Dialog>
        </>
    )
}